import { Link } from 'react-router';
import type { OperatorSession } from '../../lib/api/operatorConsole';

interface RecentSessionsCardProps {
  sessions: OperatorSession[];
}

export function RecentSessionsCard({ sessions }: RecentSessionsCardProps) {
  return (
    <section
      aria-labelledby="recent-sessions-heading"
      className="flex flex-col gap-3 rounded-[var(--radius-card,28px)] border border-[var(--ui-stroke-card,#EAEAEB)] bg-[var(--ui-bg-paper,#FFFFFF)] p-6"
    >
      <div className="flex items-center justify-between">
        <h2
          id="recent-sessions-heading"
          className="text-[15px] font-semibold text-[var(--ui-text-primary,#15181E)]"
        >
          Recent sessions
        </h2>
        <Link
          to="/sessions"
          className="text-[12px] font-medium text-[var(--ui-text-subtext,#878B95)] hover:text-[var(--ui-text-primary,#15181E)]"
        >
          See all
        </Link>
      </div>
      {sessions.length === 0 ? (
        <p className="text-[13px] text-[var(--ui-text-subtext,#878B95)]">No sessions yet.</p>
      ) : (
        <ul className="flex flex-col gap-2">
          {sessions.map((s) => (
            <li key={s.id} className="flex items-center justify-between text-[13px]">
              <Link
                to={`/sessions/${s.id}`}
                className="font-mono text-[var(--ui-text-primary,#15181E)] hover:underline"
              >
                {s.player_username ?? s.operator_account_id ?? s.operator_token}
              </Link>
              <time
                dateTime={s.created_at}
                className="text-[var(--ui-text-subtext,#878B95)]"
              >
                {new Date(s.created_at).toLocaleString()}
              </time>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
